module.exports = __webpack_public_path__ + "img/腾讯_03.d860defa.jpg";